import React, {useEffect, useState} from "react";
import GenericDialog from "../../../../components/ui/dialogs/generic-dialog/GenericDialog";
import Typography from "@material-ui/core/Typography";
import PremiumNotification from "../../../../components/ui/notifications/premium-notification/PremiumNotification";
import {ReactComponent as PremiumIcon} from "../../../../assets/images/icon-big-premium-88-px.svg";
import RichiediAssistenzaDeviceCards from "./richiedi-assistenza-device-cards/RichiediAssistenzaDeviceCards";
import {useSelector} from "react-redux";
import GuastoTerminaleDialog from "./guasto-terminale-dialog/GuastoTerminaleDialog";
import FurtoOSmarrimentoDialog from "./furto-o-smarrimento-dialog/FurtoOSmarrimentoDialog";
import PropTypes from "prop-types";
import PremiumDialog
    from "../../../../components/mobile/sub-menu-items/richieste-assistenza/Dialogs/PremiumDialog/PremiumDialog";

const DeviceAssistenzaDialog = (props) => {
    const [guastoTerminale, setGuastoTerminale] = useState(false)
    const [furtoSmarrimento, setFurtoSmarrimento] = useState(false)
    const selectedCompany = useSelector(state => state.authReducer.selectedCompany);
    const activeServiceRequest = useSelector(state => state.deviceReducer.activeServiceRequest);
    const [premiumDetailsModal, setPremiumDetailsModal] = useState(false);

    const openPremiumModal = () => setPremiumDetailsModal(!premiumDetailsModal)

    useEffect(() => {
        if (activeServiceRequest.value) {
            props.handleDialogClose();
        }
    }, [props, activeServiceRequest.value])

    const returnToMenu = () => {
        setFurtoSmarrimento(false)
        setGuastoTerminale(false)
    }

    const closeAssistenza = () => {
        returnToMenu()
        props.handleDialogClose()
    }

    const dialogContent = (
        <>
            {selectedCompany.livelloDiAssistenzaId !== 1 ? <PremiumNotification buttonText={"Scopri"}
                                                                                onClick={() => openPremiumModal()}
                                                                                icon={<PremiumIcon/>}
                                                                                title={"Assistenza Premium"}
                                                                                message={"Questo contratto prevede livello di assistenza PREMIUM con linea telefonica dedicata e SLA preferenziali"}/>
                : null}

            {!guastoTerminale && !furtoSmarrimento ?
                <RichiediAssistenzaDeviceCards
                    returnToMenu={returnToMenu}
                    setGuastoTerminale={() => setGuastoTerminale(true)}
                    setFurtoSmarrimento={() => setFurtoSmarrimento(true)}/> : null
            }
            {guastoTerminale ?
                <GuastoTerminaleDialog returnToMenu={returnToMenu}
                                       closeAssistenza={closeAssistenza}
                                       selectedDevices={props.selectedDevices}/>
                : null
            }
            {furtoSmarrimento ?
                <FurtoOSmarrimentoDialog returnToMenu={returnToMenu}
                                         closeAssistenza={closeAssistenza}
                                         selectedDevices={props.selectedDevices}/>
                : null
            }
            {premiumDetailsModal ?
                <PremiumDialog open={premiumDetailsModal}
                               close={openPremiumModal}/>
                : null}
        </>
    );

    return (
            <GenericDialog
                dialogWidth={"md"}
                open={props.open}
                handleDialogClose={props.handleDialogClose}
                handleDialogCloseButton={props.handleDialogClose}
                dialogContent={dialogContent}
                loading={activeServiceRequest.loading}
            >
                <Typography variant={"h5"}>Richiedi Assistenza</Typography>
            </GenericDialog>
    )
}

DeviceAssistenzaDialog.propTypes = {
    open: PropTypes.bool,
    selectedDevices: PropTypes.array,
    handleDialogClose: PropTypes.func
}

export default DeviceAssistenzaDialog;
